// extracted by mini-css-extract-plugin
export default {"didYouKnow":"DidYouKnow-module__didYouKnow--Nzaj4","title":"DidYouKnow-module__title--nHfQc"};